import { render, staticRenderFns } from "./WindowsDownload.vue?vue&type=template&id=5389b247&scoped=true&"
import script from "./WindowsDownload.vue?vue&type=script&lang=js&"
export * from "./WindowsDownload.vue?vue&type=script&lang=js&"
import style0 from "./WindowsDownload.vue?vue&type=style&index=0&id=5389b247&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5389b247",
  null
  
)

component.options.__file = "WindowsDownload.vue"
export default component.exports